import React from 'react'
import useBodyScrollLock from "../../hooks/useBodyScrollLock";
export default function Backdrop({ isOpen, onClose }) {
        useBodyScrollLock(isOpen);
  return (
    <div
      onClick={onClose}
      className={`fixed inset-0 bg-black/30 backdrop-blur-sm z-3 transition-all duration-300 ${
        isOpen
          ? "opacity-100 visible"
          : "opacity-0 invisible"
      }`}
    />
  )
}
